import useTranslation from "@hooks/use_translation.ts";

interface Props {
  onClear: () => void;
}

export const ClearSelectionButton = ({ onClear }: Props) => {
  const { t } = useTranslation("jobSearch");

  return (
    <button className="!pl-4 text-left" onClick={onClear}>
      {t("clearSelection")}
    </button>
  );
};
